<template lang="pug">
    div
        p.m-t-md.m-b-md.block.text-center(v-if="!type")
            | Add new items and update your existing ones. Items cannot be deleted, only altered.
        p.m-t-md.m-b-md.block.text-center(v-else)
            | Replace planogram will only update for planogram details such as sequence, facing, 
            | description. To edit planogram name, please remove the planogram and add the new one
        dropzone(
            ref="dropzone"
            id="import-product" 
            paramName="file"
            :url="url" 
            acceptedFileTypes=".csv,.xls,.xlsx"
            :maxNumberOfFiles="1"
            @vdropzone-success="uploadSuccessCallback",
            @vdropzone-error="errorHandler",
            :autoProcessQueue="false"
        )
</template>
<script>
export default {
    props: {
        type: {
            type: Number,
            required: true,
        },
    },
    computed: {
        templateUrl() {
            return Laroute.route('franchise.inventory.planogram.exportAsFile', {
                type: 'XLSX',
            });
        },

        url() {
            return Laroute.route('franchise.inventory.planogram.import');
        },

        loader() {
            return 'upload planogram file';
        },
    },

    methods: {
        uploadSuccessCallback(file, response) {
            this.$emit('success', response);
            this.removeFile();
        },

        submit() {
            if (this.onLoading(this.loader)) {
                return;
            }

            if (this.hasRejectedFile()) {
                this.showToastrError('File not valid');
                return;
            }

            if (this.hasFileToUpload()) {
                this.startLoading(this.loader);
                this.uploadFile();
            } else {
                this.showToastrError('No file selected');
            }
        },

        hasRejectedFile() {
            return this.$refs.dropzone.getRejectedFiles().length > 0;
        },

        hasFileToUpload() {
            let files = this.$refs.dropzone.getAcceptedFiles();
            return !_.isEmpty(files) && files[0].name != '';
        },

        uploadFile() {
            this.$refs.dropzone.processQueue();
        },

        errorHandler(file, error, xhr) {
            this.endLoading(this.loader);
            this.removeFile();
            this.showApiError(error, 'File Upload Failed');
        },

        cancel() {
            this.$emit('cancel');
        },

        removeFile() {
            this.$refs.dropzone.removeAllFiles();
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/franchise_component/inventory/planogram/import-planogram-form.vue